import React from "react";

import "./index.scss";
export const TextSection = ({ image }) => {
  return (
    <div className="style-text">
      <div className="container">

      <img src={image} className="img-fluid w-100" />
      </div>
    </div>
  );
};
